export default __webpack_public_path__ + "media/zurb/img/bryan/thumbs/1-96e3bfea66c348a40ce4e47f6d8bf706.png";